import styles from './PromoBlockButtons.module.scss';

const PromoBlockButtons = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={`${styles.buttons_container} jc-c`}>
      <div className={`${styles.buttons_container_inner}`}>{children}</div>
    </div>
  );
};

export default PromoBlockButtons;
